export enum MenuItemLinkType {
  Default = 'default',
  Large = 'large',
  Uppercase = 'uppercase'
}
